<section class="bg-white py-24 dark:bg-shl-navy border-b border-gray-100 dark:border-gray-800">
  <div class="mx-auto max-w-7xl px-6 lg:px-8">
    <h2 class="mb-12 text-3xl font-black text-shl-navy dark:text-white">
      {{ 'industries.title' | translate }}
    </h2>
    <div class="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
      @for (item of industries; track item.title) {
        <div class="group relative h-80 overflow-hidden rounded-xl rounded-se-[30px] cursor-pointer shadow-md">
          <img
            class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
            [attr.data-alt]="item.alt | translate"
            [src]="item.image"
            alt="{{ item.alt | translate }}"
            title="{{ item.title | translate }}"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-shl-navy to-transparent opacity-90"></div>
          <div class="absolute bottom-0 left-0 p-6 text-white">
            <h3 class="text-xl font-bold">{{ item.title | translate }}</h3>
            <p class="mt-2 text-sm text-gray-300 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              {{ item.description | translate }}
            </p>
          </div>
        </div>
      }
    </div>
  </div>
</section>
